import React, { useEffect, useState } from 'react';
import { HashLink as Link } from 'react-router-hash-link';
import i18n from 'i18n-react';
import logo from 'assets/images/logo/logo.png';
import { storageKeys, baseAppId } from 'settings';

import { RewardSearch, RewardMenu, APIHandler, StorageHandler } from 'C4';
import testData from './testdata';
import { ToastContainer, toast, cssTransition } from 'react-toastify';

const getProducts = async (callback) => {
  try {
    callback({ testData });
  } catch (error) {
    console.log(error);
  }
};

const Zoom = cssTransition({
  enter: 'zoomIn',
  exit: 'zoomOut',
  duration: [500, 800],
});

const BookingRewardsView = () => {
  const [products, setProducts] = useState([]);
  const [points, setPoints] = useState({});
  const [search, setSearch] = useState([]);
  console.log(points);
  console.log(products);

  useEffect(() => {
    if (products.length === 0) {
      getProducts((e) => {
        setProducts(e.testData);
        setSearch(e.testData);
      });
    }
    if (!(points.total >= 0)) {
      StorageHandler.load(storageKeys.accessToken).then((token) => {
        const startDate = '2021-07-21';
        const endDate = '2022-12-21';
        APIHandler.getPoints(baseAppId, startDate, endDate, token).then((res) => {
          setPoints(res.total);
        });
      });
    }
  });

  const onClick = (event) => {
    event.preventDefault();
    const id = event.target.value - 1;
    const product = search[id];

    if (points.confirmed < product.points) {
      const pointShort = `need: ${product.points} points, have: ${points.confirmed} points`;
      toast.error(pointShort, {
        position: 'top-center',
        transition: Zoom,
        autoClose: 10000,
        hideProgressBar: true,
        pauseOnHover: true,
        draggable: true,
      });
    } else {
      const bought = `bought ${product.title} for ${product.points} points`;
      toast.success(bought, {
        position: 'top-center',
        transition: Zoom,
        autoClose: 10000,
        hideProgressBar: true,
        pauseOnHover: true,
        draggable: true,
      });
    }
  };

  return (
    <div className="contentContainer BookingForm">
      <div className="header">
        <h3>{i18n.translate('rewards.bookingRewardsView.title')}</h3>
      </div>
      <hr />


      <div className="product-content">
        <div className="products">
          {search.map((e) => (
            <div className="card" key={e.id}>
              <span className="points">points : {e.points.toLocaleString()}</span>
              <div className="bottom">
                <img src={e.image} alt={e.title} data-type="image" data-fancybox={e.id} data-src={e.image} />
                <h2>{e.title}</h2>
                <span>{e.category}</span>
                <button className="btn" value={e.id} onClick={onClick}>
                  REDEEM
                </button>
              </div>
            </div>
          ))}
        </div>
      </div>
      <ToastContainer draggablePercent={70} />
      <RewardMenu />
    </div>
  );
};

export default BookingRewardsView;
